import { defineStore } from "pinia";
import { ref } from "vue";

export const useSubjectInfoStore = defineStore('subjectInfo', () => {
    const hideStartMaxPriceCheckbox = ref(false);
    const isPositionsRequired = ref(false);

    function setHideStartMaxPriceCheckbox(value) {
        hideStartMaxPriceCheckbox.value = value;
    }

    function setPositionsRequired(value) {
        isPositionsRequired.value = value;
    }

    function setDefaults() {
        hideStartMaxPriceCheckbox.value = false;
        isPositionsRequired.value = false;
    }

    return {
        hideStartMaxPriceCheckbox,
        isPositionsRequired,
        setHideStartMaxPriceCheckbox,
        setPositionsRequired,
        setDefaults,
    }
});
